import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function ErkenUnutkanlikTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['erken-unutkanlik-testi']} />;
}
